import CreateFrontData from './createFrontData';
import Utils from '../utils/util';
import * as CubeTree from '../cubeTree/index';
import { setValue } from './set';
import { hasKey, getTargetCubeAllData, allCube } from './get';

export function updateAllKeysByCubeId(cubeId: CubeId): void {
    let cube: CubeNode = CubeTree.findByCubeId(cubeId);
    let newData: FreeObjMap = CreateFrontData(cube);

    setValue(cubeId, newData);
}

export function updateAllCube(): void {
    let allCubeIds: Array<CubeId> = allCube();

    allCubeIds.forEach((cubeId: CubeId): void => {
        updateAllKeysByCubeId(cubeId);
    });
}
